import React, { useState } from "react";
import PropTypes from "prop-types";
import * as Icon from 'react-feather';
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from 'react-i18next';
const UserMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, data, screenWidth }) => {
  const { t } = useTranslation();


  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="rounded text-secondary mb-3 text-dark border">
            <Link to={`profile/${item.id}`} className="text-decoration-none">
              <div className="w-100 p-3 rounded-top" style={{ backgroundColor: "#DAF8FD" }}>
                <h5 className="text-dark fw-bolder mb-2">{item.name}</h5>
              </div>
            </Link>
            <div className="bg-white p-3 rounded-bottom">
              {/* Email */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <span style={{ fontSize: "0.7rem" }}>{t("Email")}</span>
                </div>
                <div className="col-1 text-center">
                  <span style={{ fontSize: "0.7rem" }}>:</span>
                </div>
                <div className="col-7">
                  <span style={{ fontSize: "0.7rem" }} className="fw-bold">
                    <Icon.Mail size={14} className="me-2" />
                    {item.email}
                  </span>
                </div>
              </div>
              {/* Role */}
              <div className="row mb-1">
                <div className="col-4" style={{ paddingRight: 5 }}>
                  <span style={{ fontSize: "0.7rem" }}>{t("Role")}</span>
                </div>
                <div className="col-1 text-center">
                  <span style={{ fontSize: "0.7rem" }}>:</span>
                </div>
                <div className="col-7">
                  <span style={{ fontSize: "0.7rem" }} className="fw-bold">{item.role}</span>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>No Data</p>
        </div>
      )}

      {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  );
};

UserMobile.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  screenWidth: PropTypes.number.isRequired,

  handlePageChange: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,

};

export default UserMobile;